import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Avatar from '@material-ui/core/Avatar';
import Avatar from '@material-ui/icons/AccountCircle';

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: '#44D1C2'
  },
}));

export default function ImageAvatars() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Avatar className={classes.large}></Avatar>
    </div>
  );
}